module.exports = __webpack_public_path__ + "img/coating-dirt.97544058.svg";